import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDoc = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M2 15.125h9.714v1.714H2zm0-4.062h16v1.777H2zm0-8.064h16v1.714H2zm0 3.999h16v1.778H2z" />
  </svg>
);
export default SvgDoc;
